import React from "react";
import { withStyles } from "@material-ui/core/styles";
import BaseModal from "./BaseModal";
import { inputTypes } from "../../utils/inputTypes";
import ModalForm from "./ModalForm";
import * as Yup from "yup";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { createNew, editPart, loadPartTypesAsync } from "../../actions/partActions";
import { loadCompaniesAsync } from "../../actions/companyActions";
import { showSnackbar, closeSnackbar } from "../../actions/snackbarActions";
import ApiService from "../../services/api";
import { loadStatusesAsync, loadTerminalsAsync } from "../../actions/terminalActions";


const styles = theme => ({
  paper: {
    position: "absolute",
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4
  }
});

class PartModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locations: [],
      formFields: []
    };
    this.apiService = new ApiService();
  }

  inheritLocationFormTerminal = (selectedTerminal, values) => {
    values['locationId'] = selectedTerminal;
  }

  // Function that is used for "inhereting" the location from
  // Terminal AutoComplete to Location AutoComplete.
  // This resets the update prop, telling the autocomplete
  // that there is no longer need for the "inheritance".
  resetUpdate = () => {
    const indx = this.state.formFields.findIndex(x => x.id === "locationId");
    if(indx === -1) {
      console.error("Reset update failed!")
      return;
    }

    let fields = [...this.state.formFields];
    let field = {...fields[indx]};
    field.update = undefined;
    fields[indx] = field;
    this.setState({
      formFields: fields
    })


    this.forceUpdate();
  }

  async componentDidMount() {
    const companies = (await this.props.loadCompaniesAsync()) || [];
    let locations = companies.map(l => ({ value: l, label: l.name }));
    this.setState({ locations: locations });

    const statuses = (await this.props.loadStatusesAsync()) || [];
    const partTypes = (await this.props.loadPartTypesAsync()) || [];
    const terminals = (await this.props.loadTerminalsAsync() || []);
    const mappedTerminals = terminals.map(l => ({
      value: l,
      label: l.terminalCode + ": " + l.location.name
    }));

    locations = [...this.state.locations, ...mappedTerminals];
    //this.setState({ locations: [...locations]});

    // Array of inputs that dynamically build
    // up the editor form.
    let formFields = [
      {
        id: "serialNum",
        name: "serialNum",
        label: "Serial number",
        type: inputTypes.textField
      },
      {
        id: "partTypeId",
        name: "partTypeId",
        label: "Part type",
        type: inputTypes.select,
        options: partTypes
      },
      {
        id: "statusId",
        name: "statusId",
        label: "Status",
        type: inputTypes.select,
        options: statuses
      },
      {
        id: "terminalId",
        name: "terminalId",
        label: "Terminal",
        type: inputTypes.autoComplete,
        entities: mappedTerminals,
        onChange: this.inheritLocationFormTerminal
      },
      {
        id: "locationId",
        name: "locationId",
        label: "Location",
        type: inputTypes.autoComplete,
        entities: locations
      },
      {
        id: "comment",
        name: "comment",
        label: "Comment",
        type: inputTypes.textField
      }
    ];
    
   
    this.setState({
      formFields: formFields
    })
    
  }
  
  // This function is called by the child component
  // (<BaseModal>) during its own submit function
  onSubmit = async values => {
    // Different action needs to be fired, depending on
    // whether creating new company or editing one.
    if (this.props.isEdit && this.props.selectedPart) {
      const id = this.props.selectedPart.id;
      const editedPart = { ...values, id };
      await this.props.editPart(editedPart);
      this.props.showSnackbar("Part edited");
    } else {
      await this.props.createNew(values);
      this.props.showSnackbar("New part created");
    }
  };

  // Validation schema can be difficult to build dynamically
  // in the child component. For easiness, it's created here
  // and then passed down as prop
  validationSchema = Yup.object().shape({
    serialNum: Yup.string()
      .label("Serial Number")
      .test("has-white-space", "No spaces allowed.", value => /\s/g.test(value) === false)
      .required()
      .min(1),
    partTypeId: Yup.string()
      .label("Part Type")
      .required()
      .min(1),
    comment: Yup.string()
      .label("Comment")
  });
  render() {
    const { isOpen, handleClose, isEdit, selectedPart } = this.props;

    return (
      <BaseModal
        isEdit={isEdit}
        modalType="Part"
        onSubmit={this.onSubmit}
        isOpen={isOpen}
        handleClose={handleClose}
      >
        <ModalForm
        resetUpdate={this.resetUpdate}
          locations={this.state.locations}
          validationSchema={this.validationSchema}
          initialValues={selectedPart}
          formFields={this.state.formFields}
          handleCancel={handleClose}
        />
      </BaseModal>
    );
  }
}
export default compose(
  withStyles(styles),
  connect(
    null,
    { createNew, editPart, showSnackbar, closeSnackbar, loadStatusesAsync, loadPartTypesAsync, loadTerminalsAsync, loadCompaniesAsync }
  )
)(PartModal);



// WEBPACK FOOTER //
// ./src/components/Modals/PartModal.js